/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
import{newIntersector as e}from"../3d/webgl-engine/lib/Intersector.js";import{StoreResults as o}from"../3d/webgl-engine/lib/IntersectorInterfaces.js";function t(t){const n=e(t);return n.options.store=o.MIN,n.options.excludeLabels=!0,n}export{t as newToolIntersector};
